export const REQUEST_STATUS_CONFIRMED = Symbol('REQUEST_STATUS_CONFIRMED')
export const REQUEST_STATUS_FAILED = Symbol('REQUEST_STATUS_FAILED')
export const REQUEST_STATUS_PENDING = Symbol('REQUEST_STATUS_PENDING')
export const REQUEST_STATUS_PROCESSED = Symbol('REQUEST_STATUS_PROCESSED')
export const REQUEST_STATUS_PROCESSING_FAILED = Symbol(
  'REQUEST_STATUS_PROCESSING_FAILED'
)
export const REQUEST_STATUS_UPCOMING = Symbol('REQUEST_STATUS_UPCOMING')
